import { render, staticRenderFns } from "./CouponPreviewFooter.vue?vue&type=template&id=1c7c3d8c&scoped=true&"
import script from "./CouponPreviewFooter.vue?vue&type=script&lang=js&"
export * from "./CouponPreviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreviewFooter.vue?vue&type=style&index=0&id=1c7c3d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c3d8c",
  null
  
)

export default component.exports